// LLM generated - Model Claude 4 Sonnet
export function RYPlogoLogin({
  height = 15,
  color = '#495057',
}: {
  height?: number;
  color?: string;
}) {
  // Calculate width based on original aspect ratio (93/15 ≈ 6.2)
  const width = height * (93 / 15);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 93 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Union">
        <path d="M90.4418 12V0H92.8418V12H90.4418Z" fill={color} />
        <path
          d="M19.8175 2.96269C17.2685 2.96269 15.5968 4.43579 15.5968 7.11717V11.9999H17.9968V7.01786C17.9968 5.84269 18.6423 5.19717 19.8175 5.19717C20.9926 5.19717 21.6381 5.84269 21.6381 7.01786V11.9999H24.0381V7.11717C24.0381 4.43579 22.3664 2.96269 19.8175 2.96269Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.4707 7.58062C33.4707 10.2951 35.3907 12.1985 38.1052 12.1985C40.8197 12.1985 42.7397 10.2951 42.7397 7.58062C42.7397 4.86614 40.8197 2.96269 38.1052 2.96269C35.3907 2.96269 33.4707 4.86614 33.4707 7.58062ZM40.3397 7.58062C40.3397 8.98751 39.4128 9.96407 38.0886 9.96407C36.781 9.96407 35.8707 8.98751 35.8707 7.58062C35.8707 6.17372 36.7976 5.18062 38.1052 5.18062C39.4128 5.18062 40.3397 6.17372 40.3397 7.58062Z"
          fill={color}
        />
        <path
          d="M48.1179 12.1985C45.6186 12.1985 43.9138 10.6923 43.9138 8.47441V3.22752H46.3138V8.15993C46.3138 9.41786 46.9759 9.93096 48.1179 9.93096C49.3097 9.93096 49.9552 9.41786 49.9552 8.15993V3.22752H52.3552V8.47441C52.3552 10.6923 50.6338 12.1985 48.1179 12.1985Z"
          fill={color}
        />
        <path
          d="M53.6276 7.3489C53.6276 4.61786 55.0014 3.22752 57.6828 3.22752H58.4276V5.462H57.8814C56.4745 5.462 56.0276 5.95855 56.0276 7.3489V11.9999H53.6276V7.3489Z"
          fill={color}
        />
        <path
          d="M26.7253 14.6482L27.735 11.9172L24.044 3.22752H26.626L28.9598 9.11993L31.0453 3.22752H33.5612L29.2247 14.6482H26.7253Z"
          fill={color}
        />
        <path
          d="M10.0871 12.1985C7.5878 12.1985 5.88297 10.6923 5.88297 8.47441V3.22752H8.28297V8.15993C8.28297 9.41786 8.94504 9.93096 10.0871 9.93096C11.2788 9.93096 11.9244 9.41786 11.9244 8.15993V3.22752H14.3244V8.47441C14.3244 10.6923 12.603 12.1985 10.0871 12.1985Z"
          fill={color}
        />
        <path
          d="M4.05517 3.22752C1.37379 3.22752 0 4.61786 0 7.3489V11.9999H2.4V7.3489C2.4 5.95855 2.8469 5.462 4.25379 5.462H4.8V3.22752H4.05517Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.9321 7.58069C79.9321 10.2952 81.8521 12.1986 84.5666 12.1986C87.2811 12.1986 89.2011 10.2952 89.2011 7.58069C89.2011 4.86621 87.2811 2.96276 84.5666 2.96276C81.8521 2.96276 79.9321 4.86621 79.9321 7.58069ZM86.8011 7.58069C86.8011 8.98759 85.8742 9.96414 84.55 9.96414C83.2425 9.96414 82.3321 8.98759 82.3321 7.58069C82.3321 6.17379 83.259 5.18069 84.5666 5.18069C85.8742 5.18069 86.8011 6.17379 86.8011 7.58069Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.2224 12.1986C71.5079 12.1986 69.5879 10.2952 69.5879 7.58069C69.5879 4.86621 71.5079 2.96276 74.2224 2.96276C76.9369 2.96276 78.8569 4.86621 78.8569 7.58069C78.8569 10.2952 76.9369 12.1986 74.2224 12.1986ZM74.2059 9.96414C75.53 9.96414 76.4569 8.98759 76.4569 7.58069C76.4569 6.17379 75.53 5.18069 74.2224 5.18069C72.9148 5.18069 71.9879 6.17379 71.9879 7.58069C71.9879 8.98759 72.8983 9.96414 74.2059 9.96414Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.36 7.41517C59.3269 7.91172 59.3103 8.34207 59.3103 9.00414V14.6483H61.6938V11.04C62.2234 11.7352 63.1172 12.1324 64.2428 12.1324C66.6593 12.1324 68.5131 10.229 68.5131 7.7131C68.5131 4.98207 66.7917 2.96276 63.8621 2.96276C61.2469 2.96276 59.509 4.68414 59.36 7.41517ZM66.1297 7.56414C66.1297 8.97103 65.2359 9.91448 63.9117 9.91448C62.571 9.91448 61.7103 9.00414 61.7103 7.56414C61.7103 6.19035 62.6041 5.19724 63.9117 5.19724C65.2359 5.19724 66.1297 6.19035 66.1297 7.56414Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
